import { useCallback } from 'react'

import { useEventListener } from './useEventListener'

const useKey = (
  eventName: string,
  keys: Array<string>,
  handler: (event: Event) => void,
  deps: Array<any>,
) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const keyCodeCallback = useCallback(handler, deps)
  useEventListener(
    eventName,
    (event: Event) => {
      if (keys.includes((event as KeyboardEvent).key)) {
        return keyCodeCallback(event)
      }
      return null
    },
    [keyCodeCallback, keys],
  )
}

export const useKeyPress = (
  key: string | Array<string>,
  handler: (event: Event) => void,
  deps: Array<any>,
) => {
  const keys = Array.isArray(key) ? key : [key]
  return useKey('keyup', keys, handler, deps)
}
export const useKeyDown = (
  key: string | Array<string>,
  handler: (event: Event) => void,
  deps: Array<any>,
) => {
  const keys = Array.isArray(key) ? key : [key]
  return useKey('keydown', keys, handler, deps)
}
